import { PureComponent } from 'react';
import { isNil, noop, get } from 'lodash';

function applyTransforms(value, transforms = []) {
  if (!transforms.length) {
    return value;
  }

  return transforms.reduce((accumulator, transform) => transform(accumulator), value);
}

export default function withTransforms(
  ComponentToWrap,
  transformConf = {
    inputTransforms: [],
    outputTransforms: [],
  }
) {
  class WithTransforms extends PureComponent {
    static defaultProps = {
      name: undefined,
      onBlur: noop,
      onChange: noop,
    };

    _transformOutputEvent = (event) => {
      const value = get(event.target, 'value');

      if (!isNil(value)) {
        const _value = applyTransforms(value, transformConf.outputTransforms);

        return {
          ...event,
          target: {
            type: get(event.target, 'type'),
            // @ts-expect-error TS(2339): Property 'name' does not exist on type 'Readonly<{... Remove this comment to see the full error message
            name: this.props.name,
            value: _value,
          },
        };
      }

      return event;
    };

    onChange = (event, ...rest) => {
      // @ts-expect-error TS(2339): Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
      this.props.onChange(this._transformOutputEvent(event, ...rest));
    };

    onBlur = (event, ...rest) => {
      // @ts-expect-error TS(2339): Property 'onBlur' does not exist on type 'Readonly... Remove this comment to see the full error message
      this.props.onBlur(this._transformOutputEvent(event, ...rest));
    };

    render() {
      // @ts-expect-error TS(2339): Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
      // eslint-disable-next-line prefer-const
      let { value, onChange, onBlur, name, ...rest } = this.props;
      value = applyTransforms(value, transformConf.inputTransforms);

      return <ComponentToWrap {...rest} name={name} onChange={this.onChange} onBlur={this.onBlur} value={value} />;
    }
  }

  return WithTransforms;
}
